// stores/categories/categoriesStore.js
import { defineStore } from 'pinia';
import { api } from '../../services/api';
import { useGamesStore } from '../games/gamesStore';
import config from '../../config';


export const useCategoriesStore = defineStore('categories', {
  state: () => ({
    categories: [],
    selectedCategory: 'all-games',
    isLoading: false,  // Añadir estado de carga
    isLoaded: false    // Añadir flag de carga completada
  }),

  actions: {
    async loadCategories() {
      if (this.isLoaded) return; // Evitar cargas múltiples
      
      this.isLoading = true;
      try {
        const response = await api.get('/player/categories');
        if (response.data.success && response.data.categories) {
          // Esperar a que todas las imágenes estén precargadas
          const categories = response.data.categories;
          const imagePromises = categories
            .filter(category => category.image)
            .map(category => {
              const url = `${config.storageUrl}/categories/${category.image}`;
              return new Promise((resolve) => {
                const img = new Image();
                img.onload = () => resolve(url);
                img.onerror = () => resolve(null);
                img.src = url;
              });
            });

          await Promise.all(imagePromises);

          this.categories = categories.map(category => ({
            ...category,
            image_url: category.image ?
              `${config.storageUrl}/categories/${category.image}` : null
          }));
          
          this.isLoaded = true;
        }
      } catch (error) {
        console.error('Error loading categories:', error);
      } finally {
        this.isLoading = false;
      }
    },

    setSelectedCategory(categorySlug) {
      this.selectedCategory = categorySlug;
      const gamesStore = useGamesStore();
      gamesStore.filterGamesByCategory(categorySlug);
    },

    updateCategories(categories) {
      this.categories = categories;
    }
  },

  getters: {
    getCategoryBySlug: (state) => (slug) => {
      return state.categories.find(category => category.slug === slug);
    },
    
    getSystemCategories: (state) => {
      return state.categories.filter(category => category.is_system);
    }
  }
});
